// import { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {  getAdminProfile, updateAdminProfile, clearMessages } from '../../Slice/AdminAddSlice';
// import Navbar from '../Pages/Navbar';


// function Profile() {
//   const dispatch = useDispatch();
//   const { profile, loading, error, success } = useSelector((state) => state.adminAdd);
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');

//   useEffect(() => {
//     dispatch(getAdminProfile());
//   }, [dispatch]);

//   useEffect(() => {
//     if (profile) {
//       setName(profile.name);
//       setEmail(profile.email);
//     }
//   }, [profile]);

//   useEffect(() => {
//     if (success) {
//       setTimeout(() => {
//         dispatch(clearMessages());
//       }, 2000);
//     }
//   }, [success, dispatch]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     dispatch(updateAdminProfile({ name, email }));
//   };

//   return (
//     <div className="container mx-auto p-8">
//       <Navbar/>
//       <div className="max-w-lg mx-auto bg-white p-8 rounded-lg shadow-lg">
//         <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Admin Profile</h2>
//         {error && <p className="text-red-500 text-center">{error}</p>}
//         {success && <p className="text-green-500 text-center">{success}</p>}
//         {loading ? (
//           <p className="text-center">Loading...</p>
//         ) : (
//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div>
//               <label className="block text-sm font-medium text-white">Name</label>
//               <input
//                 type="text"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 className="w-full px-4 py-2 mt-1 border rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-white">Email</label>
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className="w-full px-4 py-2 mt-1 border rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-white">Role</label>
//               <input
//                 type="text"
//                 value={profile?.role || ''}
//                 className="w-full px-4 py-2 mt-1 border rounded-md bg-gray-100"
//                 disabled
//               />
//             </div>
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition disabled:opacity-50"
//             >
//               {loading ? 'Updating...' : 'Update Profile'}
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Profile;


import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  getAdminProfile, updateAdminProfile, clearMessages } from '../../Slice/AdminAddSlice';
import Navbar from '../Pages/Navbar';
import AdminSidebar from '../Pages/AdminSidebar';

function Profile() {

  const dispatch = useDispatch();
  const { profile, loading, error, success } = useSelector((state) => state.adminAdd);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    dispatch(getAdminProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile) {
      setName(profile.name);
      setEmail(profile.email);
    }
  }, [profile]);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        dispatch(clearMessages());
      }, 2000);
    }
  }, [success, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(updateAdminProfile({ name, email }));
  };

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="w-full min-h-screen bg-cover bg-Fabcbg bg-[#1F1F1F] ">
      <Navbar />
      <div className='w-full flex relative '>
        {/* <div className=' fixed '>
         <AdminSidebar />
         </div> */}
      <div className=" lg:px-4 py-12 w-[90%] mx-auto lg:w-[85%] h-full lg:flex justify-end items-end overflow-hidden overflow-y-auto ">
        <div className="w-full">
          <div className="text-center mb-10">
            {/* <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-6">
              <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div> */}
            <h1 className="text-3xl font-bold text-FABcYellow mb-3 ">Admin Profile</h1>
            <p className="text-sm text-white">Manage your personal information and account details</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 ">
            <div className="md:col-span-1">
              <div className="bg-[#D9D9D90F] rounded-2xl shadow-xl border border-gray-100/20 p-8 text-center">
                <div className="mb-6">
                  {profile?.name ? (
                    <div className="w-24 h-24 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                      <span className="text-2xl font-bold text-white">
                        {getInitials(profile.name || 'A')}
                      </span>
                    </div>
                  ) : (
                    <div className="w-16 h-16 bg-[#D9D9D90F] rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
                      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                    </div>
                  )}
                  
                  <h3 className="text-xl font-bold text-white mb-2">
                    {profile?.name || 'Loading...'}
                  </h3>
                  <p className="text-white mb-4">
                    {profile?.email || 'Loading...'}
                  </p>
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    {profile?.role || 'Admin'}
                  </span>
                </div>

                <div className="border-t border-gray-100/20 pt-6">
                  <div className="grid grid-cols-1 gap-4 text-sm">
                    <div className="flex justify-between">
                      <span className="text-white">Status</span>
                      <span className="flex items-center text-green-600">
                        <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                        Active
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-white">Last Updated</span>
                      <span className="text-white">Today</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Profile Form */}
            <div className="md:col-span-2">
              <div className="bg-[#D9D9D90F] rounded-2xl shadow-xl border border-gray-100/20 overflow-hidden">
                {/* Status Messages */}
                {(error || success) && (
                  <div className="px-8 pt-6">
                    {error && (
                      <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-4 transition-all duration-300">
                        <div className="flex items-center">
                          <svg className="w-5 h-5 text-red-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <p className="text-red-700 font-medium">{error}</p>
                        </div>
                      </div>
                    )}
                    {success && (
                      <div className="bg-[#D9D9D90F] border border-green-200 rounded-xl p-4 mb-4 transition-all duration-300">
                        <div className="flex items-center">
                          <svg className="w-5 h-5 text-green-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <p className="text-green-700 font-medium">{success}</p>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                <div className="p-8">
                  <div className="flex items-center space-x-3 mb-8">
                    <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                      <svg className="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-white">Edit Profile</h2>
                      <p className="text-white">Update your personal information</p>
                    </div>
                  </div>

                  {loading ? (
                    <div className="flex items-center justify-center py-12">
                      <div className="flex items-center space-x-3">
                        <div className="w-8 h-8 border-3 border-purple-200 border-t-purple-600 rounded-full animate-spin"></div>
                        <span className="text-lg text-white">Loading profile...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <label className="block text-sm font-semibold text-white ">Full Name</label>
                          <div className="relative">
                            <input
                              type="text"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              className="w-full px-4 py-3 pl-12 border border-gray-300/60 rounded-xl bg-[#D9D9D91A] text-white transition-all duration-200 focus:outline-none"
                              onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                  handleSubmit(e);
                                }
                              }}
                            />
                            <svg className="w-5 h-5 text-gray-400 absolute left-4 top-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                          </div>
                        </div>

                        <div className="space-y-2">
                          <label className="block text-sm font-semibold text-white">Email Address</label>
                          <div className="relative">
                            <input
                              type="email"
                              value={email}
                              disabled
                              onChange={(e) => setEmail(e.target.value)}
                              className="w-full px-4 py-3 pl-12 focus:outline-none border border-gray-300/60 rounded-xl text-white bg-[#D9D9D91A] transition-all duration-200 cursor-not-allowed"
                              onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                  handleSubmit(e);
                                }
                              }}
                            />
                            <svg className="w-5 h-5 text-gray-400 absolute left-4 top-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-white">Role</label>
                        <div className="relative">
                          <input
                            type="text"
                            value={profile?.role || ''}
                            className="w-full px-4 py-3 pl-12 border border-gray-300/60 rounded-xl bg-[#D9D9D91A] text-white cursor-not-allowed"
                            disabled
                          />
                          <svg className="w-5 h-5 text-gray-400 absolute left-4 top-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                          </svg>
                        </div>
                        <p className="text-sm text-white">Your role is assigned by the system administrator</p>
                      </div>

                      <div className="flex flex-col sm:flex-row gap-4 pt-6">
                        <button
                          onClick={handleSubmit}
                          disabled={loading}
                          className="flex-1 flex items-center justify-center px-6 py-3 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-semibold shadow-sm hover:shadow-md"
                        >
                          {loading ? (
                            <div className="flex items-center space-x-2">
                              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                              <span>Updating...</span>
                            </div>
                          ) : (
                            <div className="flex items-center space-x-2">
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                              <span>Update Profile</span>
                            </div>
                          )}
                        </button>
                        <button
                          onClick={() => {
                            setName(profile?.name || '');
                            setEmail(profile?.email || '');
                          }}
                          className="px-6 py-3 bg-[#D9D9D90F] text-white rounded-xl transition-all duration-200 font-semibold"
                        >
                          Reset Changes
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Additional Actions Card */}
          <div className="mt-8 bg-[#D9D9D90F] rounded-xl border border-gray-100/20 p-6 shadow-sm">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-FABcBlue " fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="text-lg font-semibold text-white mb-2">Need to change your password?</h4>
                <p className="text-white text-sm leading-relaxed mb-4">
                  For security reasons, password changes are handled separately. Contact your system administrator 
                  or visit the security settings to update your password.
                </p>
                <button className=" text-FABcBlue hover:text-indigo-700 font-semibold text-sm transition-colors">
                  Go to Security Settings →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Profile;